export enum SubscriptionDeliveryCount {
	Deliveries3 = "Deliveries3",
	Deliveries6 = "Deliveries6",
	Deliveries12 = "Deliveries12",
}
